/* eslint class-methods-use-this:0 */
import app from '../store/modules/app';

class NotificationHandler {
  showNotification(msg, type) {
    app.commit('SHOW_NOTIFICATION', { msg, type });
  }

  closeNotification() {
    app.commit('DELETE_NOTIFICATION');
  }
}

const notificationHandler = new NotificationHandler();

export default notificationHandler;
